import React from 'react'
import useSWRMutation from 'swr/mutation'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { saveLinkedinUserProfile } from '../../../api/auth'
import Loading from '../../components/layout/Loading'
import { CurrentUserContext } from '../../../libraries/auth'
import { patchOnboardingUser, updateOnboardingCompleted } from '../../../api/users'
import { showLinkedinVerificationBeforeOnBoarding } from '../../../libraries/auth/linkedinVerification'
import { ANALYTICS_EVENTS, useAnalytics } from '../../../libraries/posthog'
import ErrorMessage from '../../components/errors/ErrorMessage'
import Button from '../../components/form/Button'

let verifyingLinkedin = false

const LinkedinVerification = () => {
  const navigate = useNavigate()
  const { trackEvent } = useAnalytics()
  const { currentUser, refetchCurrentUser, removeLinkedinStorage } = React.useContext(CurrentUserContext)
  const { trigger: updateUser, isMutating: isUpdatingUser } = useSWRMutation('/users', patchOnboardingUser)
  const { trigger: completeOnboarding } = useSWRMutation('/users', updateOnboardingCompleted, { populateCache: true })

  const { isMutating: isVerifyingLinkedin, trigger } = useSWRMutation('/users/auth/linkedin-verification', saveLinkedinUserProfile, { onSuccess: async (data) => {
    if(data?.sub) {
      // new users doing linkedin verification before onboarding

      if(showLinkedinVerificationBeforeOnBoarding(!!currentUser?.onboardingCompleted) && !currentUser) {
        return navigate('/onboarding/personal', { replace: true })
      }

      // existing users AND new users doing linkedin verification after onboarding
      if(currentUser) {
        await updateUser({ body: { name: currentUser.name, lastName: currentUser.lastName, onboardingCompleted: currentUser.onboardingCompleted, linkedinSub: data.sub } })
        removeLinkedinStorage()

        if(!showLinkedinVerificationBeforeOnBoarding(!!currentUser?.onboardingCompleted) && !currentUser?.onboardingCompleted) {
          // new users
          await completeOnboarding()
          trackEvent(ANALYTICS_EVENTS.ONBOARDING_COMPLETED)
        }
        await refetchCurrentUser()
        return navigate('/', { replace: true })
      }
    }
  }})

  const handleSubmit = (code: string) => {
    // Only trigger if not already mutating
    if (!verifyingLinkedin) {
      verifyingLinkedin = true
      trigger(code)
    }
  }

  const [urlSearchParams] = useSearchParams()

  React.useEffect(() => {
    const code = urlSearchParams.get('code')
    if(!code) {
      window.alert('Invalid auth code')
      return
    }
    handleSubmit(code)
  }, [])

  if(isVerifyingLinkedin || isUpdatingUser || !currentUser?.onboardingCompleted) {
    return <div className='flex justify-center w-full text-center'><Loading /></div>
  }

  return (
    <>
      <ErrorMessage message={'Verification failed, please try again by refreshing this page'} />
      <Button onClick={() => window.location.reload()}>Reload</Button>
    </>
  )
}

export default LinkedinVerification
